/**
 * Lett obfuskering av lokalt cachet plass-data.
 *
 * ÆRLIG PREMISS: dette er en fartsdump, ikke ekte sikkerhet. Alt en klient kan
 * vise, kan en bestemt bruker hente ut. Poenget er å hindre at en tilfeldig
 * titt i IndexedDB/localStorage (devtools, backup-dump) gir en ferdig,
 * kopier-lim-bar JSON-eksport av fricamp-plassene. Den EGENTLIGE kontrollen mot
 * skraping er serverside (Firestore-regler + rate-limiting), ikke dette.
 *
 * XOR med en repeterende nøkkel + base64. UTF-8-trygg.
 */

const KEY = new Uint8Array([0x46, 0x72, 0x69, 0x63, 0x61, 0x6d, 0x70, 0x21, 0x9c, 0x3b, 0xd7, 0x5e]);

export function obfuscate(input: string): string {
  const bytes = new TextEncoder().encode(input);
  const out = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    out[i] = bytes[i] ^ KEY[i % KEY.length];
  }
  let bin = '';
  for (let i = 0; i < out.length; i++) bin += String.fromCharCode(out[i]);
  return btoa(bin);
}

/** Reverserer obfuscate. Returnerer null hvis input ikke er gyldig (f.eks. gammel klartekst). */
export function deobfuscate(input: string): string | null {
  try {
    const bin = atob(input);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      bytes[i] = bin.charCodeAt(i) ^ KEY[i % KEY.length];
    }
    return new TextDecoder().decode(bytes);
  } catch {
    return null;
  }
}
